export default (a, b) => {
  if (a.datetime !== b.datetime) {
    return b.datetime - a.datetime;
  }
  return b.id - a.id;
};
